import React from 'react';
import ReactDOM from 'react-dom';
import { fetchData } from '../../../../helpers/base_data_fetcher';
import PostcodeLookup from './components/PostcodeLookup';
import { getStoredAddress } from './helpers';

/* Mount PostcodeLookup component */

const elementId: string = 'address_lookup';
const mountElement: HTMLElement | null = document.getElementById(elementId);

const addressLookupPostcode = (): void => {
  if (mountElement) {
    Promise.all([fetchData('page'), fetchData('site')]).then(
      ([pageData, siteData]) => {
        const {
          addressLookupServiceUrl,
          addressLookupServiceKey,
          retainedStreet,
          retainedPostcode,
        } = mountElement.dataset;

        // Get mobile / desktop
        const { mobile } = siteData;
        const isMobile = mobile === '1';

        // Get localisations
        const { post_ad: localisations } = pageData;

        // Get address data stored in the session
        let storedAddress = JSON.parse(getStoredAddress());

        // Get values retained by the backend
        if (retainedStreet || retainedPostcode) {
          storedAddress = {
            ...storedAddress,
            line_2: retainedStreet,
            postcode: retainedPostcode,
          };
        }

        // Some context for the tracking
        const trackingContext = pageData.name.includes('wholeproperty')
          ? 'place_whole_property'
          : 'place_room_offered';

        // Let's do this...
        ReactDOM.render(
          <PostcodeLookup
            alsUrl={addressLookupServiceUrl}
            alsKey={addressLookupServiceKey}
            isMobile={isMobile}
            localisations={localisations}
            storedAddress={storedAddress}
            trackingContext={trackingContext}
          />,
          mountElement,
        );
      },
    );
  }
};

export default addressLookupPostcode;
